// extracted by mini-css-extract-plugin
export default {"Subreddits":"Subreddits_Subreddits__KS5yP","header":"Subreddits_header__YwcWD","expandBtn":"Subreddits_expandBtn__0kVJ8"};